/**
 * Texts for Press Releases page
 */
export const pressReleasesPageText = {
    title: 'Pressemeldinger - CamAPS FX',
    titleMeta: 'Pressemeldinger - CamAPS FX',
    descriptionMeta: 'Siste pressemeldinger og nyheter fra CamAPS FX.',
    keywords: 'camaps pressemeldinger, camaps nyheter, diabetes teknologi nyheter',
    localeMeta: 'nb_no',

    bannerTitle: 'Pressemeldinger',
    bannerSubtitle: 'Hold deg oppdatert med våre siste kunngjøringer',

    contactText: 'For pressehenvendelser, kontakt via <a href="mailto:media@camdiab.com">media@camdiab.com</a>',
    pressReleasesDisclaimer: 'Alle pressemeldinger publiseres på engelsk.',

    download: 'Last ned',
    showMore: 'Vis mer',
    showLess: 'Vis mindre',
};

